import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { connect } from "react-redux"
import LoginForm from "./LoginForm"
import LoginActionButtons from "./LoginActionButtons"
import { signInFormSubmitted } from "./actions"
import { getAutoCloseMessage, isStateLoading } from "../../filters/selectors"
import { getCurrentPath } from "../../router/selectors"
import UnauthorizedContentBox from "../../common/UnauthorizedContentBox"
import { Color } from "../../../constants"
import { AutoCloseMessageComponent } from "../../common/components/AutoCloseMessage/AutoCloseMessageComponent"
import type { AutoCloseMessage } from "../../filters/reducer"

type Props = {
    isProcessing: boolean
    currentPath: Record<string, any>
    onSubmit: (email: string, password: string) => void
    autoCloseMessage?: Maybe<AutoCloseMessage>
}

const LoginComponent = ({ autoCloseMessage = null, ...props }: Props) => {
    const passwordReseted = props.currentPath && props.currentPath.query.passwordReset
    const loginError = props.currentPath?.query?.error
    return (
        <UnauthorizedContentBox>
            {autoCloseMessage && (
                // @ts-expect-error
                <AutoCloseMessageComponent text={autoCloseMessage.text} type={autoCloseMessage.type} />
            )}
            <div className={classes.logo} />
            <h2
                style={{
                    textAlign: "center",
                    fontWeight: 700,
                    fontSize: 20,
                    paddingTop: 24,
                    color: "#66717d",
                }}>
                Sign In
            </h2>
            {loginError ? (
                <div
                    style={{
                        color: Color.Red,
                        textAlign: "center",
                        marginBottom: "1rem",
                    }}>
                    {loginError === "no-access"
                        ? "Access Denied. Please contact your account administrator for access."
                        : "The email and password you entered did not match our records. Please double-check and try again."}
                </div>
            ) : null}
            {passwordReseted && (
                <div
                    style={{
                        color: Color.PrimaryColor,
                        textAlign: "center",
                        marginBottom: "1rem",
                    }}>
                    Password was successfully changed!
                </div>
            )}
            {/* @ts-expect-error */}
            <LoginForm isProcessing={props.isProcessing} onSubmit={props.onSubmit} loginError={!!loginError} />
            <LoginActionButtons />
        </UnauthorizedContentBox>
    )
}

const classes = {
    logo: "mt-3 h-12 w-full bg-[url('/figure-logo.svg')] bg-contain bg-center bg-no-repeat",
}

const mapStateToProps = state => ({
    currentPath: getCurrentPath(state),
    isProcessing: isStateLoading(state, "login-form"),
    autoCloseMessage: getAutoCloseMessage(state),
})

const mapDispatchToProps = {
    onSubmit: signInFormSubmitted,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(LoginComponent)
